import script from "./PayinBlockedNotification.vue?vue&type=script&lang=jsx&setup=true"
export * from "./PayinBlockedNotification.vue?vue&type=script&lang=jsx&setup=true"

const cssModules = {}
import style0 from "./PayinBlockedNotification.vue?vue&type=style&index=0&id=1dbddcf4&module=true&scoped=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-1dbddcf4"]])

export default __exports__